<ss-modal
  modalwidth="20"
  [open]="openModal"
  [enableCloseOutside]="enableCloseOutside"
  [label]="dataModal?.label ?? label"
  [showClosingX]="!dataModal?.saveState?.isProcessing"
  (closeClick)="onModalCloseClick($event)"
>
  <form slot="modal-body" class="flex flex-col gap-y-4 mt-6 items-center">
    <span>{{
      fileSelected()?.name
        ? 'Selected file name: ' + fileSelected()?.name
        : 'No file selected yet.'
    }}</span>
    <div class="flex">
      <ss-button
        (click)="file.click()"
        [disabled]="dataModal?.saveState?.isProcessing"
        >Choose file</ss-button
      >
    </div>
    @if (fileSelected()) {
      <div class="flex">
        <ss-button
          [actionState]="dataModal?.saveState"
          (click)="saveFileSubmit()"
          >Save</ss-button
        >
      </div>
    }
    <input
      class="hidden"
      #file
      type="file"
      [accept]="dataModal?.acceptsFileTypes"
      (change)="onFileSelected($event)"
    />
    @if (dataModal?.saveState?.error) {
      <span class="text-ss-error text-center"
        >An error has occurred. Please try again.</span
      >
    }
  </form>
</ss-modal>
